import React, {useEffect, useState} from 'react';
import {css, styled} from 'styled-components';
import {colors} from '../../styles/colors';
import DefaultImageView from 'components/common/DefaultImageView';
import ScreenLayout from 'components/common/ScreenLayout';
import {getDevice} from 'utils/getDevice';
import DefaultText from 'components/common/DefaultText';
import {useRecoilValue} from 'recoil';
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';
import ContainerHeader from 'components/common/ContainerHeader';
import {minmax} from 'utils/minmax';
import DefaultInput from 'components/common/DefaultInput';
import Footer from 'components/common/Footer';
import WorkerList from 'components/userMenagement/WorkerList';
import {searchWorker} from 'function/api';
import {userInfoState} from 'utils/Atoms';
import {RoleList} from 'components/userMenagement/RoleList';
import LabelInput from 'components/common/LabelInput';

/**
 * 초기 필터 데이터
 * 검색 필터의 초기값을 정의합니다.
 * @property {string} keyword - 검색 키워드
 * @property {string} affiliation - 소속
 * @property {string} physicalCondition - 신체 조건
 */
export const initialFilterData: {[key: string]: string} = {
  keyword: '',
  affiliation: '',
  physicalCondition: '',
  // state: '', // TODO! 추후 상태 업데이트하면 세팅
};

/**
 * 옵션 타입
 * @property {string} text - 표시 텍스트
 * @property {any} value - 옵션 값
 */
type IOption = {text: string; value: any};

/**
 * 사용자 관리 현장 상세 페이지 컴포넌트
 * 특정 현장의 근로자 목록을 조회하고 관리하는 페이지입니다.
 * @returns {JSX.Element} 사용자 관리 현장 상세 페이지 컴포넌트
 */
const UserManagementTongPlaceDetail = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const device = getDevice();

  const userInfo = useRecoilValue(userInfoState);

  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({});

  const [filterData, setFilterData] = useState(initialFilterData);

  const [searchParams, setSearchParams] = useSearchParams();

  const [data, setData] = useState<any | null>(null);

  const [currentPage, setCurrentPage] = useState(1);

  const [uuid, setUUID] = useState('');

  // 모달
  const [modal, setModal] = useState('');

  const [selectWorker, setSelectWorker] = useState<null | any>(null);

  const defaultProps = {
    userInfo,
    setErrorModal,
    setIsLoading,
  };

  useEffect(() => {
    if (state?.uuid) {
      setUUID(state.uuid);
    }
  }, [state]);

  /**
   * 근로자 목록을 조회합니다.
   * 현장 UUID를 기반으로 근로자 목록을 가져옵니다.
   * @returns {Promise<void>}
   */
  const getWorkerList = async () => {
    if (uuid) {
      // TODO: 근로자 목록 가져오기
      const keyword = searchParams.get('keyword') ?? '';
      const result = await searchWorker({
        userInfo,
        setIsLoading,
        setErrorModal,
        tongPlaceUUID: uuid,
        keyword,
        count: 10,
        page: currentPage,
      });
      result && setData(result);
      console.log('result', result);
      setData(result);
    }
  };
  useEffect(() => {
    getWorkerList();
  }, [uuid, currentPage, searchParams.toString()]);

  useEffect(() => {
    const keyword = searchParams.get('keyword');
    const affiliation = searchParams.get('affiliation');
    const physicalCondition = searchParams.get('physicalCondition');
    const page = searchParams.get('page') ?? 1;
    const object = {
      keyword: keyword,
      affiliation: affiliation,
      physicalCondition: physicalCondition,
    };

    const filterValues = {...initialFilterData};

    Object.entries(object).forEach(([key, value]) => {
      filterValues[key] = value ?? '';
    });

    setFilterData(filterValues);
    setCurrentPage(Number(page));
  }, [searchParams.toString()]);

  const modalData: {[key: string]: any} = {
    servicePreparing: {
      title: 'servicePreparing',
      firstButtonText: 'confirm',
      firstButtonClick: () => {
        setModal('');
      },
    },
  };

  /**
   * 필터 조건을 URL 파라미터에 추가합니다.
   * 빈 값은 제외하고 페이지를 1로 초기화합니다.
   * @returns {void}
   */
  const addFilterPath = () => {
    const object = {...filterData};
    Object.entries(object).forEach(([key, value]) => {
      if (!value) {
        delete object[key];
      }
    });
    object['page'] = '1';
    setSearchParams(object);
  };

  return (
    <ScreenLayout isLoading={isLoading} errorModal={errorModal}>
      {/* <ServicePreparingInnerModal /> */}
      <Container>
        <ContainerHeader mainTitle="userManagement" subTitle="tongPlace" />

        <Inner $device={device} style={{paddingTop: minmax(20)}}>
          <Header>
            <DefaultText
              text="workerList"
              textStyle={{
                fontSize: minmax(30),
                fontWeight: 'bold',
                borderBottom: `3px solid ${colors.primary}`,
                width: 'fit-content',
                marginBottom: minmax(20),
              }}
            />
            <DefaultText text={data?.tongPlace?.name} />
          </Header>

          <InfoContainer>
            <InfoInner>
              <DefaultText
                text="tongOWNER"
                textStyle={{
                  textWrap: 'nowrap',
                  marginRight: minmax(80),
                  width: minmax(400),
                }}
              />
              <LabelInput
                type={'text'}
                labelText={'name'}
                value={data?.tongPlace?.owner?.profile?.name}
                inputStyle={{border: 0, backgroundColor: 'transparent'}}
              />
              <LabelInput
                type={'text'}
                labelText={'phone'}
                value={data?.tongPlace?.owner?.profile?.phone}
                inputStyle={{border: 0, backgroundColor: 'transparent'}}
              />
            </InfoInner>
            <InfoInner>
              <DefaultText
                text="constructionOperationsManager"
                textStyle={{
                  textWrap: 'nowrap',
                  marginRight: minmax(80),
                  width: minmax(400),
                }}
              />
              <LabelInput
                type={'text'}
                labelText={'name'}
                value={data?.contractor?.owner?.profile?.name}
                inputStyle={{border: 0, backgroundColor: 'transparent'}}
              />
              <LabelInput
                type={'text'}
                labelText={'phone'}
                value={data?.contractor?.owner?.profile?.phone}
                inputStyle={{border: 0, backgroundColor: 'transparent'}}
              />
            </InfoInner>
          </InfoContainer>

          <SearchArea>
            <InputWrap>
              <DefaultInput
                value={filterData.keyword}
                setValue={(e: any) =>
                  setFilterData({...filterData, keyword: e})
                }
                placeholderText="workerListSearchPlaceholder"
                wrapperStyle={{height: '100%'}}
                onKeyPress={(e: any) => {
                  if (e.key === 'Enter') {
                    addFilterPath();
                  }
                }}
              />
              <DefaultImageView
                source="images/common/search.png"
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  height: '100%',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  getWorkerList();
                  addFilterPath();
                }}
              />
            </InputWrap>
          </SearchArea>

          <WorkerList
            data={data}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onClickWorker={worker => setSelectWorker(worker)}
          />
        </Inner>
      </Container>
      <Footer isMain />

      {selectWorker && (
        <RoleList
          selectWorker={selectWorker}
          closeModal={() => setSelectWorker(null)}
          defaultProps={defaultProps}
        />
      )}
    </ScreenLayout>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  margin-bottom: ${minmax(120)};
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  column-gap: ${minmax(27)};
  align-items: center;
`;

const Inner = styled.div<{$device?: string}>`
  width: 90%;
  padding-bottom: max(12px, min(1.5vw, 24px));
  padding-left: 2%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props: any) =>
    props.$device !== 'pc' &&
    css`
      width: 100%;
    `}
`;

const SearchArea = styled.div`
  width: 100%;
  height: ${minmax(60)};
  margin-top: ${minmax(20)};
  display: flex;
  flex-direction: row;
  column-gap: 2%;
`;

const InputWrap = styled.div`
  width: 100%;
  position: relative;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${minmax(16)};
  background-color: ${colors.lighterGray};
  width: 100%;
  padding: ${minmax(30)};
`;

const InfoInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default UserManagementTongPlaceDetail;
